import { useQuery } from 'react-query';

import { LARSIRSettings } from '../interfaces/larsSettings';
import { getSettings } from '../utils/fetchSettings';
import { SETTINGS_QUERY_KEY } from '../constants/queryKey';

export default function useSettings() {
	const {
		data: settings,
		error: settingsError,
		isLoading: settingsIsLoading,
		status: settingsStatus,
		...others
	} = useQuery<LARSIRSettings, Error>(SETTINGS_QUERY_KEY, getSettings, {
		staleTime: Infinity,
	});

	// immutably rename these keys to settings-specific names
	return {
		settings,
		settingsError,
		settingsIsLoading,
		settingsStatus,
		...others,
	};
}
